<div class="size-selection-manager">
  
  <!-- Debug Info (only in development) -->
  <!-- 
  <div class="debug-info" *ngIf="false">
    <h6>Debug Info:</h6>
    <pre>{{ getDebugInfo() | json }}</pre>
  </div>
  -->

  <!-- Search-by-Size Selector (for search-by-size routes) -->
  <app-wheel-search-by-size-selector
    *ngIf="shouldShowSearchBySize()"
    [product]="product"
    [vehicleWheels]="vehicleWheels"
    [checkfitment]="checkfitment"
    (onCartItemsChange)="handleCartItemsChange($event)"
    (onPriceChange)="handlePriceChange($event)">
  </app-wheel-search-by-size-selector>

  <!-- Regular Selector (for vehicle-based search) -->
  <app-wheel-regular-size-selector
    *ngIf="shouldShowRegular()"
    [product]="product"
    [vehicleWheels]="vehicleWheels"
    [checkfitment]="checkfitment"
    (onCartItemsChange)="handleCartItemsChange($event)"
    (onPriceChange)="handlePriceChange($event)">
  </app-wheel-regular-size-selector>

  <!-- Fallback message if no selector matches -->
  <div class="no-selector-message" *ngIf="!shouldShowSearchBySize() && !shouldShowRegular()">
    <div class="alert alert-info">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      Unable to determine search type. Please refresh the page or contact support.
    </div>
  </div>

</div>
